import  Login from 'ant-design-pro/lib/Login';
import { Alert,message, Input } from 'antd';
import React from 'react';
import './login.css';
import Axios from 'axios';
import API, { getAxiosInstance } from '../api/api';

console.log(Login);
const {
  UserName, Password, Submit,
} = Login;

interface LoginPageProps{
    onLogginVerified:Function
}

interface SubmitValues{
    username:string,
    password:string,
}
class LoginPage extends React.Component<LoginPageProps> {
  state = {
    notice: '',
    type: 'tab2',
    loading: false,
    otp:'',
  }
  loginForm:any;

  onSubmit = (err:Error, values:SubmitValues) => {
    if (!err) {
      const { username, password } = values;
      const { otp } = this.state;
      this.setState({ loading: true });
      getAxiosInstance().post(API.login, { username, password, otp }).then((res:any) => {
        this.setState({ loading: false });
        res.status = (res.data.status === 'true');

        if (res.data.status === true) {
          localStorage.setItem('connectionSession', res.data.data.token);
          localStorage.setItem('deviceId', res.data.data.deviceId);
          localStorage.setItem('sessionId', res.data.data.sessionId);
          localStorage.setItem('userType', res.data.data.userType)
          this.props.onLogginVerified();
        } else {
          this.setState({ notice: 'Login failed, wrong username/password' });
        }
      }).catch(err=>{
        this.setState({ loading: false });
        console.error(err);
        message.error(err.stack);
      });

      // login here
    }
    //
  }
  handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ otp: e.target.value });
  };

  render() {
    return (
      <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/login.jpg)` }} className="loginContainer">
        {/* <img src="/assets/images/bg1.jpg" /> */}
        <div className="mainLoginManagement">
          <Login
            ref={(form) => {
              this.loginForm = form;
            }}
            defaultActiveKey={this.state.type}
            onSubmit={this.onSubmit}
          >
            <p style={{ fontSize: '3em', color: 'white', textAlign: 'center' }}>GOGO Driver</p>
            {
              this.state.notice
              && <Alert style={{ marginBottom: 24 }} onClose={() => { this.setState({ notice: null }); }} message={this.state.notice} type="error" showIcon closable />
            }
            {/*
  // @ts-ignore */}
            <UserName name="username" />
            {/*
  // @ts-ignore */}
            <Password onPressEnter={() => this.loginForm.validateFields(this.onSubmit)} name="password" />

            <Input
              placeholder="Enter OTP"
              value={this.state.otp}
              onChange={this.handleOtpChange}
            />

            <Submit loading={this.state.loading}>Login</Submit>

          </Login>
        </div>
      </div>


    );
  }
}

export default LoginPage;
